import React from "react";
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close'; // Import Close icon
import { DownloadForOfflineSharp } from "@mui/icons-material";

const PreviewModal = ({ open, onClose, content, notification, notificationsPerPage, focusIndex, changePreviewNotification , totalNotifications }) => {
  console.log(notification)
  const handleDownload = () => {
    const blob = new Blob([content?.notificationBody], { type: 'text/html' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${notification?.notificationId}.html`; // Set the file name
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url); // Clean up the URL object
  };

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      PaperProps={{ style: { maxWidth: '800px' } }} // Set max width here
    >
      <DialogTitle style={{ fontWeight: 'bold', position: 'relative', background: 'white', zIndex: 1 }}>
        Notification Preview
        <Typography variant="h6" style={{ fontWeight: 'bold' }}>
          Email : <span>{notification?.deliveryDestination} </span>
        </Typography>
        <Typography variant="h6" style={{ fontWeight: '400' }}>
          Title : {content?.notificationTitle}
        </Typography>
        <div style={{ position: 'absolute', right: 8, top: 8 }}>
          <Button onClick={() => changePreviewNotification(focusIndex - 1)} color="primary" title="Previous Email" disabled={focusIndex<=0}>
            Previous
          </Button>
          <Button onClick={() => changePreviewNotification(focusIndex + 1)} color="primary" title="Next Email" disabled={focusIndex==notificationsPerPage-1 || focusIndex==totalNotifications-1}>
            Next
          </Button>
          <Button onClick={handleDownload} color="primary" title="Download Email">
            <DownloadForOfflineSharp /> 
          </Button>
          <Button onClick={onClose} color="inherit">
            <CloseIcon />
          </Button>
        </div>
      </DialogTitle>
      <DialogContent>
        <Typography dangerouslySetInnerHTML={{ __html: content?.notificationBody }} />
      </DialogContent>
      <DialogActions>
      </DialogActions>
    </Dialog>
  );
};

export default PreviewModal;
